import type { ReactNode } from "react"
import {
  Card,
  Divider,
  Footer,
  FooterBlock,
  IconBox,
  STAT_CARD_DEFAULT_ACCENT,
  StatCardDescription,
  StatCardTitle,
  StatIconWrap,
  StatItem,
  StatLabel,
  StatsRow,
  StatText,
  StatValue,
  StimulusColorCircle,
  TextBlock,
  WrapperDeleteButton,
} from "./style"
import { ButtonClose } from "../buttons/button-close"

export type StatCardStat = {
  icon: ReactNode
  value: string
  label: string
}

export type StatCardProps = {
  title: string
  description: string
  stimulusColor?: string
  leadingIcon?: ReactNode
  stats: StatCardStat[]
  footerContent?: ReactNode
  accentColor?: string
  className?: string
  onClose?: () => void
  linkTo?: string
}

export const StatCard: React.FC<StatCardProps> = ({
  title,
  description,
  stimulusColor,
  leadingIcon,
  stats,
  footerContent,
  accentColor = STAT_CARD_DEFAULT_ACCENT,
  className,
  onClose,
}) => {
  const showFooter = Boolean(footerContent)
  const desc = description.trim()
  const showDescription = Boolean(desc)
  const stimulusSwatch = stimulusColor?.trim() ?? ""
  const showStimulusSwatch = Boolean(stimulusSwatch)
  const showLeadingIcon =
    !showStimulusSwatch && leadingIcon != null && leadingIcon !== false
  const showLeading = showStimulusSwatch || showLeadingIcon
  const showStats = stats.length > 0

  return (
    <Card className={className}>
      {onClose && (
        <WrapperDeleteButton>
          <ButtonClose onClick={onClose} />
        </WrapperDeleteButton>
      )}
      {showLeading && (
        <IconBox>
          {showStimulusSwatch ? (
            <StimulusColorCircle style={{ backgroundColor: stimulusSwatch }} />
          ) : (
            <span
              style={{
                color: accentColor,
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {leadingIcon}
            </span>
          )}
        </IconBox>
      )}
      <TextBlock>
        <StatCardTitle>{title}</StatCardTitle>
        {showDescription && <StatCardDescription>{desc}</StatCardDescription>}
      </TextBlock>
      {showStats && (
        <StatsRow>
          {stats.map((stat, index) => (
            <StatItem key={index}>
              <StatIconWrap>{stat.icon}</StatIconWrap>
              <StatText>
                <StatValue>{stat.value}</StatValue>
                <StatLabel>{stat.label}</StatLabel>
              </StatText>
            </StatItem>
          ))}
        </StatsRow>
      )}
      {showFooter && (
        <FooterBlock>
          <Divider />
          <Footer>{footerContent}</Footer>
        </FooterBlock>
      )}
    </Card>
  )
}
